module.exports = __webpack_public_path__ + "static/media/6.8fc4ead1.JPG";